@if (field.input_type === 'checkbox') {
  <label class="flex flex-row min-h-12 w-full cursor-pointer items-center gap-3 px-1 py-1" style="display: flex; flex-direction: row;">
    <p-toggleswitch class="inline-flex shrink-0" size="small" [formControl]="control" [attr.aria-label]="field.name ?? field.identifier" />
    <span class="flex min-w-0 flex-1 self-stretch items-center text-sm font-medium leading-5" [class.text-slate-600]="isDetail" [class.text-gray-600]="!isDetail">{{ field.name ?? field.identifier }}</span>
  </label>
} @else {
  <div #controlRoot class="flex flex-col gap-1" (focusout)="onFocusOut($event, controlRoot)">
    @if (showLabel) {
      <span class="text-xs" [class.text-slate-500]="isDetail" [class.text-gray-400]="!isDetail">{{ field.name ?? field.identifier }}</span>
    }

    @if (field.input_type === 'select') {
      <app-select
        [formControl]="control"
        [options]="options"
        optionLabel="label"
        optionValue="value"
        [searchInInput]="true"
        [showClear]="!field.is_required"
        [appendTo]="'body'"
        [placeholder]="field.name ?? field.identifier"
        (optionSelected)="onSelectChange()"
      />
    } @else if (field.input_type === 'date') {
      <div
        [class]="isDetail ? 'grid grid-cols-2 gap-2' : 'grid gap-1.5'"
        [style.grid-template-columns]="isDetail ? null : 'minmax(0, 1.32fr) minmax(104px, 0.68fr)'"
      >
        <p-datepicker
          styleClass="w-full"
          [fluid]="true"
          dataType="string"
          dateFormat="yy-mm-dd"
          [showButtonBar]="true"
          [appendTo]="'body'"
          panelStyleClass="board-v3-datepicker-panel"
          [inputStyleClass]="datePickerInputClass"
          [formControl]="control"
          [ariaLabel]="field.name ?? field.identifier"
          (onShow)="keepDateFocusForPicker()"
          (onSelect)="onDateChange(); keepDateFocusForPicker()"
          (onInput)="onDateChange()"
          (onClear)="onDateChange()"
        />
        @if (dateTimeControl; as timeControl) {
          <p-datepicker
            styleClass="w-full"
            [fluid]="true"
            dataType="string"
            [timeOnly]="true"
            hourFormat="24"
            [stepMinute]="1"
            [appendTo]="'body'"
            panelStyleClass="board-v3-datepicker-panel"
            [inputStyleClass]="timePickerInputClass"
            [formControl]="timeControl"
            [disabled]="!control.value"
            ariaLabel="Час"
            (onShow)="keepDateFocusForPicker()"
            (onSelect)="keepDateFocusForPicker()"
          />
        }
      </div>
    } @else if (field.input_type === 'text') {
      <input
        type="text"
        [attr.maxlength]="maxLength"
        [formControl]="control"
        [placeholder]="field.name ?? field.identifier"
        [class]="isDetail ? 'h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none focus:border-orange-400' : 'h-10 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-800 outline-none focus:border-blue-400'"
        [class.border-red-400]="control.invalid && control.touched"
      />
    } @else if (field.input_type === 'textarea') {
      <textarea
        rows="4"
        [attr.maxlength]="maxLength"
        [formControl]="control"
        [placeholder]="field.name ?? field.identifier"
        [class]="isDetail ? 'min-h-40 max-h-52 w-full resize-y overflow-y-auto rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium leading-6 text-slate-800 outline-none focus:border-orange-400' : 'min-h-24 w-full resize-y rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-800 outline-none focus:border-blue-400'"
        [class.border-red-400]="control.invalid && control.touched"
      ></textarea>
    } @else if (field.input_type === 'price') {
      <div
        [class]="isDetail
          ? 'flex items-center gap-2'
          : 'grid min-w-0 grid-cols-[minmax(0,1fr)_104px] items-center gap-2'"
      >
        <input
          type="text"
          inputmode="decimal"
          [formControl]="priceAmountControl"
          [placeholder]="field.name ?? field.identifier"
          [class]="isDetail ? 'h-10 min-w-0 flex-1 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none focus:border-orange-400' : 'h-9 w-full min-w-0 rounded-[var(--p-inputtext-border-radius)] border border-gray-200 bg-white px-3 text-sm text-gray-800 outline-none focus:border-blue-400'"
          [class.border-red-400]="control.invalid && control.touched"
          (input)="onPriceInput($event); onPriceAmountChange()"
        />
        <app-select
          [class]="isDetail
            ? 'w-[116px] shrink-0 self-center'
            : 'block w-[104px] min-w-0 shrink-0 self-center [&_.p-select]:!h-9 [&_.p-select]:!min-w-0 [&_.p-select-label]:!px-3 [&_.p-select-label]:!py-1.5 [&_.p-select-label]:!text-sm [&_.p-select-dropdown]:!w-8'"
          [formControl]="priceCurrencyControl"
          [options]="currencyOptions"
          optionLabel="label"
          optionValue="value"
          [fluid]="false"
          [appendTo]="'body'"
          (pointerdown)="keepPriceFocusForSelect()"
          (opened)="keepPriceFocusForSelect()"
          (optionSelected)="onPriceCurrencyChange()"
        />
      </div>
    } @else if (['number', 'phone', 'email', 'link'].includes(field.input_type)) {
      <input
        [type]="inputType"
        [attr.inputmode]="inputMode"
        [formControl]="control"
        [placeholder]="field.name ?? field.identifier"
        [class]="isDetail ? 'h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none focus:border-orange-400' : 'h-10 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-800 outline-none focus:border-blue-400'"
        [class.border-red-400]="control.invalid && control.touched"
        (input)="onPhoneInput($event)"
      />
    } @else {
      <app-input [formControl]="control" [inputType]="'default'" [placeholder]="field.name ?? field.identifier" />
    }

    @if (shouldShowCharacterLimit) {
      <span class="self-end text-xs font-medium" [class.text-slate-400]="isDetail" [class.text-gray-400]="!isDetail">
        {{ valueLength }}/{{ maxLength }}
      </span>
    }

    @if (control.invalid && control.touched) {
      <p class="text-xs text-red-500">{{ errorKey | translate: { value: maxLength } }}</p>
    }
  </div>
}
